import type { CSSProperties } from 'react';

/** Base path for marketing photos (mirrored from SharePoint to public/). */
export const MARKETING_IMG = '/images/marketing/website';

/**
 * Stagger-reveal index – the prototype's `style="--idx:N"` data attribute that
 * drives staggered reveal delays. In React: `style={idx(n)}`.
 */
export function idx(n: number): CSSProperties {
  return { ['--idx' as string]: n } as CSSProperties;
}
